import { render, staticRenderFns } from "./PublicationCard.vue?vue&type=template&id=b3fb44a2&scoped=true"
import script from "./PublicationCard.vue?vue&type=script&lang=js"
export * from "./PublicationCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3fb44a2",
  null
  
)

export default component.exports